// File: src/pages/UserDashboard.jsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

/** 
 *  a) Has a generated placeholder (like react-content-loader) - we'll just show a static skeleton
 *  b) A message in the middle about logging in and more features
 *  c) A button leading to the community blog
 */
const UserDashboard = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        User Dashboard
      </Typography>

      {/* Placeholder skeleton */}
      <Box
        sx={{
          width: '100%',
          height: 150,
          backgroundColor: '#eee',
          borderRadius: 2,
          mb: 2,
        }}
      />

      <Box
        sx={{
          width: '100%',
          height: 100,
          backgroundColor: '#eee',
          borderRadius: 2,
          mb: 2,
        }}
      />

      {/* Centered message */}
      <Box sx={{ textAlign: 'center', my: 4 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Thank you for logging in! We are currently adding more features to the website.
        </Typography>
        <Button
          variant="contained"
          component={Link}
          to="/community-blog"
        >
          Go to Community Blog
        </Button>
      </Box>
    </Box>
  );
};

export default UserDashboard;
